exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control:focus {\n  border-color: #b9c2cc;\n}\n.min-width-custom-calendar {\n  min-width: 350px;\n}\n.custom-calendar-input-padding {\n  padding: 18px 10px;\n}\n.custom-calendar-checkbox > div {\n  min-width: 230px;\n}\n.custom-calendar-checkbox .custom-checkbox {\n  word-break: break-word;\n  width: 25%;\n}\n", ""]);

// exports
